// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomerInformation_stepTitle__pEHwN {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 15px;
  text-align: center;
}

.CustomerInformation_stepSubTitle__Bm\\+hF {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--primary-dark-blue);
  border-bottom: 2px solid #f0f4f8;
  padding-bottom: 10px;
  margin-top: 40px;
  margin-bottom: 20px;
}

.CustomerInformation_inputGroup__W9IMZ {
  margin-bottom: 25px;
}

.CustomerInformation_inputGroup__W9IMZ label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.CustomerInformation_inputGroup__W9IMZ input,
.CustomerInformation_inputGroup__W9IMZ select {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  background-color: white;
}

.CustomerInformation_inputGroup__W9IMZ input:focus,
.CustomerInformation_inputGroup__W9IMZ select:focus {
  outline: none;
  border-color: var(--secondary-bright-blue);
  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);
}

.CustomerInformation_inputGrid__uskIQ {
  display: grid;
  /* 240px min so paired fields stack to full width on phones (giving long
     emails/addresses room) while staying two-up on tablet and desktop */
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
}

.CustomerInformation_errorMessage__x69Uk {
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/CustomerInformation/CustomerInformation.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb;wEACsE;EACtE,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.stepSubTitle {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--primary-dark-blue);\n  border-bottom: 2px solid #f0f4f8;\n  padding-bottom: 10px;\n  margin-top: 40px;\n  margin-bottom: 20px;\n}\n\n.inputGroup {\n  margin-bottom: 25px;\n}\n\n.inputGroup label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.inputGroup input,\n.inputGroup select {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  background-color: white;\n}\n\n.inputGroup input:focus,\n.inputGroup select:focus {\n  outline: none;\n  border-color: var(--secondary-bright-blue);\n  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);\n}\n\n.inputGrid {\n  display: grid;\n  /* 240px min so paired fields stack to full width on phones (giving long\n     emails/addresses room) while staying two-up on tablet and desktop */\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n}\n\n.errorMessage {\n  color: #e53e3e;\n  font-size: 0.875rem;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `CustomerInformation_stepTitle__pEHwN`,
	"stepSubTitle": `CustomerInformation_stepSubTitle__Bm+hF`,
	"inputGroup": `CustomerInformation_inputGroup__W9IMZ`,
	"inputGrid": `CustomerInformation_inputGrid__uskIQ`,
	"errorMessage": `CustomerInformation_errorMessage__x69Uk`
};
export default ___CSS_LOADER_EXPORT___;
